import { isMobileApp } from '@/utils/general/device-info';
import * as mime from '@/utils/general/mime-types';

// TODO: Take a look at all the //NOTE: comments here. Are we actually doing something wrong?

interface MB_createFormDataProps {
  dataForFile: {
    /**
     * The formData key for the file.
     */
    key: string;
    /**
     * Blob is used when creating form data for web.
     * Pass undefined if it`s only used on mobile.
     */
    blob: Blob | undefined;
    /**
     * uri is used when creating form data for mobile apps.
     * Pass undefined if it`s only used on web.
     */
    uri: string | undefined;
  }[];

  /**
   * Use this to attach primitive data (Non-Files) to the formData.
   * Note taht if you pass an Object, it will be converted to string by calling JSON.stringify.
   */
  dataForPrimitives?: { key: string; value: string | number }[] | Object;
}

const MB_formDataCreator = {
  createFormData: async ({ dataForFile, dataForPrimitives }: MB_createFormDataProps): Promise<FormData> => {
    // TODO: This should not be async
    const formData = new FormData();
    if (dataForFile.length > 0) {
      dataForFile.forEach(fileData => {
        if (isMobileApp) {
          if (!fileData.uri) {
            throw 'createFormData expects uri to not be empty or undefined when running on mobile apps';
          }

          const type = fileData.blob?.type ?? mime.lookup(fileData.uri);

          //Note:  Had to cast the argument to any otherwise typescript was complaining since it expects the form data value to be a blot | string
          const formDataValue = {
            name: fileData.uri.split('/').pop(),
            type: !type ? 'application/octet-stream' : type,
            uri: fileData.uri,
          } as any;

          formData.append(fileData.key, formDataValue);
        } else {
          if (!fileData.blob) {
            throw 'createFormData expects blob to not be undefined when running on web';
          }

          formData.append(fileData.key, fileData.blob);
        }
      });
    }

    if (dataForPrimitives) {
      if (Array.isArray(dataForPrimitives)) {
        if (dataForPrimitives && dataForPrimitives.length > 0) {
          dataForPrimitives.forEach(extraData => {
            //Note:  Had to cast the argument to any otherwise typescript was complaining since it expects the form data value to be a blot | string
            formData.append(extraData.key, extraData.value as any);
          });
        }
      } else {
        // Extract key values from object and append to formData.
        // IMPORTANT: All non string | number values will be converted to string via JSON.stringify
        Object.keys(dataForPrimitives).forEach(key => {
          let value: string | number = dataForPrimitives[key as keyof typeof dataForPrimitives] as any;
          if (typeof value !== 'string' && typeof value !== 'number') {
            value = JSON.stringify(value);
          }

          //Note: Had to cast the argument to any otherwise typescript was complaining since it expects the form data value to be a blot | string
          formData.append(key, value as any);
        });
      }
    }

    return formData;
  },
};

export { MB_formDataCreator };
